import axios from "axios";

export function fetchDistributionAreasAction(bid) {
    return {
        type: 'FETCH_DISTRIBUTION_AREAS',
        meta: {
            bid: bid
        },
        payload: async () => {
            const distribution_areas_resp = await axios.get(`/api/v2/distributionAreas/${bid}`);

            return distribution_areas_resp.data;
        }
    };
}

export function editDistributionAreaAction(distributionArea) {
    return {
        type: "EDIT_DISTRIBUTION_AREA",
        meta: distributionArea,
        payload: axios.put(`/api/v2/distributionAreas/${distributionArea.bid}`, distributionArea)
    };
}